export default class DietaryPreferences {
  constructor(vegan = false, vegetarian = false, halal = false, kosher = false) {
    this.vegan = vegan;
    this.vegetarian = vegetarian;
    this.halal = halal;
    this.kosher = kosher;
  }
}
